const dictionary = {
  index: 'Home',

  // PT-BR
  'trabalhe-conosco': 'Trabalhe Conosco',
  vagas: 'Vagas',
  'programas-de-carreira': 'Programas de Carreira',
  cultura: 'Cultura',

  // EN
  jobs: 'Jobs',
  positions: 'Positions',
  culture: 'Culture',

  // ES
  'trabaja-con-nosotros': 'Trabaja con nosotros',
  ofertas: 'Ofertas',
}

export default dictionary
